import sanitize from 'sanitize-html';

export default ({ html }) => sanitize(html, {
  allowedTags: ['a', 'b', 'br', 'i', 'p', 'u'],
  allowedAttributes: { a: ['href', 'rel', 'target'], br: [] },
});
